<template>
  <div>
    <div class="top-banner">
      <img src="@/assets/topbanner.jpg" alt="华洲电力" class="banner-img" />
    </div>
    
    <!-- 主营业务部分 -->
    <div class="main-business">
      <h2 class="business-title">主营业务</h2>
      <div class="business-grid">
        <div v-for="(business, index) in currentPageBusinesses" :key="index" class="business-card">
          <div class="business-image">
            <img :src="business.image" :alt="business.title" />
          </div>
          <h3 class="business-name">{{ business.title }}</h3>
          <p class="business-desc">{{ business.description }}</p>
          <a href="#" class="learn-more">了解详情</a>
        </div>
      </div>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination 
          background 
          layout="prev, pager, next" 
          @current-change="handleCurrentChange"
          :total="10" 
          :page-size="6"
          class="custom-pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BusinessPage',
  metaInfo: {
    title: '主营业务 - 华洲电力建设有限公司',
    meta: [
      {
        name: 'description',
        content: '华洲电力建设有限公司主营业务包括输变电工程、地基基础工程、消防设施工程、防水防腐保温工程、电力工程施工总承包等多项专业工程服务。'
      },
      {
        name: 'keywords',
        content: '华洲电力,主营业务,输变电工程,地基基础工程,消防设施工程,电力工程施工'
      },
      {
        name: 'author',
        content: '华洲电力建设有限公司'
      },
      {
        property: 'og:title',
        content: '主营业务 - 华洲电力建设有限公司'
      },
      {
        property: 'og:description',
        content: '华洲电力建设有限公司主营业务包括输变电工程、地基基础工程、消防设施工程、防水防腐保温工程、电力工程施工总承包等多项专业工程服务。'
      },
      {
        property: 'og:type',
        content: 'website'
      }
    ]
  },
  data() {
    return {
      // 主营业务数据
      businesses: [
        { title: '输变电工程', description: '具有国家建设部颁发的"电力工程施工总承包...', image: require('@/assets/business1.png') },        
        { title: '地基基础工程', description: '具有国家建设部颁发的"地基基础工程专业...', image: require('@/assets/business2.png') },        
        { title: '消防设施工程', description: '具有国家建设部颁发的"消防设施工程专业...', image: require('@/assets/business3.png') },        
        { title: '防水防腐保温工程', description: '具有国家建设部颁发的"防水防腐保温工程专业...', image: require('@/assets/business4.png') },        
        { title: '电力工程施工总承包', description: '具有国家建设部颁发的"电力工程施工总承包...', image: require('@/assets/business5.png') },        
        { title: '起重设备安装工程', description: '具有国家建设部颁发的"起重设备安装工程专业...', image: require('@/assets/business6.png') },
        { title: '电子与智能化工程', description: '具有国家建设部颁发的"“电力工程施工总承包...', image: require('@/assets/business7.png') },  
        { title: '环保工程', description: '具有国家建设部颁发的"“地基基础工程专业...', image: require('@/assets/business8.png') },  
        { title: '市政公用工程', description: '具有国家建设部颁发的"“消防设施施工专业...', image: require('@/assets/business9.png') },  
        { title: '建筑工程', description: '具有国家建设部颁发的"“防水防腐保温工程专...', image: require('@/assets/business10.png') },  
      ],
      // 合作企业
      companies: [],
      currentPage: 1,
    }
  },

  mounted() {
    // 页面加载时获取数据
    this.fetchApprovedCompanies()
  },
  computed: {
    // 计算当前页显示的业务数据
    currentPageBusinesses() {
      const startIndex = (this.currentPage - 1) * 6;
      const endIndex = startIndex + 6;
      return this.businesses.slice(startIndex, endIndex);
    }
  },
  methods: {
    // 处理页码切换
    handleCurrentChange(page) {
      this.currentPage = page;
    },
    // 页面加载时获取数据
    fetchApprovedCompanies() {
      axios.get('/webapi/company/approved')
        .then(response => {
          if (response.data.ActionType === 'OK' && response.data.data) {
            this.companies = response.data.data
          } else {
            console.error('获取公司数据失败:', response.data.Message)
          }
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
  },
}
</script>

<style scoped>
.top-banner {
}

/* 全新的分页样式 - 直接覆盖Element UI默认样式 */
.custom-pagination { /* 不使用:deep()，直接使用类选择器 */
  /* 重置一些基础样式 */
}

/* 针对分页数字按钮 */
.pagination-container .el-pagination .el-pager li {
  transition: all 0.3s ease;
}

/* 激活状态的页码 - 使用高优先级选择器 */
.pagination-container .el-pagination .el-pager li.active {
  background-color: #3f5ff0 !important;
  color: white !important;
  border-color: #3f5ff0 !important;
}

/* 悬停状态的页码 */
.pagination-container .el-pagination .el-pager li:hover {
  background-color: #3f5ff0 !important;
  color: white !important;
  border-color: #3f5ff0 !important;
}

/* 上一页下一页按钮 */
.pagination-container .el-pagination .btn-prev:hover,
.pagination-container .el-pagination .btn-next:hover {
  background-color: #3f5ff0 !important;
  color: white !important;
  border-color: #3f5ff0 !important;
}

/* 确保所有按钮元素都应用样式 */
.pagination-container .el-pagination button,
.pagination-container .el-pagination span:not(.el-pagination__total) {
  transition: all 0.3s ease;
}

.top-banner {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.top-banner .banner-img {
  width: 100%;
  height: auto;
  display: block;
}

/* 主营业务部分 */
.main-business {
  padding: 50px 0;
  text-align: center;
}

.business-title {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 50px;
  position: relative;
  display: inline-block;
}

.business-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #3f5ff0;
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto 50px;
  padding: 0 20px;
}

.business-card {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.business-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}

.business-image {
  width: 100%;
  height: 220px;
  overflow: hidden;
}

.business-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.business-card:hover .business-image img {
  transform: scale(1.05);
}

.business-name {
  font-size: 1.2rem;
  color: #333;
  margin: 20px 0 10px;
  font-weight: 500;
}

.business-desc {
  font-size: 0.9rem;
  color: #666;
  padding: 0 20px 20px;
  margin: 0;
  line-height: 1.6;
}

.learn-more {
  display: inline-block;
  margin: 0 20px 20px;
  color: #3f5ff0;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.learn-more:hover {
  color: #66b1ff;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.page-number {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-number:first-child {
  background-color: #409eff;
  color: white;
  border-color: #409eff;
}

.page-number:hover:not(.page-more) {
  background-color: #f5f5f5;
}

.page-more {
  color: #999;
  cursor: default;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .business-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .business-grid {
    grid-template-columns: 1fr;
  }
  
  .business-title {
    font-size: 1.8rem;
  }
  
  .business-image {
    height: 180px;
  }
}
</style>
